module.exports = __webpack_public_path__ + "static/img/NL.d008a06f.png";